import React from 'react'
import useTranslation from 'next-translate/useTranslation'
// import { ProductTypeType } from '@/types/Product'
import { Text } from '@/components/Text'

interface ProductInfoProps {
  inStock: boolean
  perOrder: boolean
  perOrderWaitTime?: number
}

const ProductInfo: React.VFC<ProductInfoProps> = ({
  inStock,
  perOrder,
  perOrderWaitTime,
}) => {
  const { t } = useTranslation('common')

  return (
    <Text>
      {inStock
        ? t('in_stock')
        : perOrder
        ? t('per-order', { count: perOrderWaitTime })
        : t('out_of_stock')}
    </Text>
  )
}

export default ProductInfo
